/**
 * Section heading with an optional subtitle line.
 *
 * Props:
 *   title    — main heading text
 *   subtitle — optional smaller text below the title
 */
export function SectionHeading({ title, subtitle }) {
  return (
    <div className="mb-5">
      <h2
        className="text-xl font-semibold text-slate-800"
        style={{ fontFamily: "'DM Serif Display', serif" }}
      >
        {title}
      </h2>
      {subtitle && <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p>}
    </div>
  );
}
